// extracted by mini-css-extract-plugin
export var carouselItemImgWrapper = "media-carousel-module--carouselItemImgWrapper--idRn7";
export var carouselSlide = "media-carousel-module--carouselSlide--3U-d6";
export var video = "media-carousel-module--video--GywXh";
export var videoSlide = "media-carousel-module--videoSlide--vUcK+";